export default __webpack_public_path__ + "static/media/promoIcon.38f4a063.svg";